// 学习中心
export default [{
    // 操作指南
    path: 'operation_guide',
    name: 'm_operation_guide',
    component: () => import('@/pages/help/operation_guide_list')
},{
    // 操作指南
    path: 'platform_rule',
    name: 'm_platform_rule',
    component: () => import('@/pages/help/platform_rule_list')
},{  // 操作指南、平台规则详情
    path: 'help_detail/:id',
    name: 'help_detail',
    props: route => route.params,
    component: () => import('@/pages/help/help_detail')
}];